export default class StoreMenuGroupModel {
  storeCode;
  groupCode;
  name;
  isDefault;
  useType;
  startUseTime;
  endUseTime;
  useTime;

  constructor(data) {
    Object.assign(this, data);
    this.useTime = data.useTime ? JSON.parse(data.useTime) : null;
  }
}
